module.exports = __webpack_public_path__ + "img/ru_success_2.c235d995.png";